import { SslRobotService } from './robot';
import * as Types from '@/types';

export class CsrDecoderService {
    public static $inject: string[] = ['sslRobot'];

    constructor(
        private sslRobot: SslRobotService
    ) {}

    public decode = (csrKey: string, productCode?: string): Promise<Types.SslApi.DecodeCsrResult> => {
        return this.sslRobot.csrDecode(csrKey, productCode)
            .then((result: Types.UI.APISingleResponse<Types.SslApi.DecodeCsrResult>) => result.response);
    };
}
